<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/placement-skill/${inputs.id}` : `transaction/placement-skill`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_skills" class="col-sm-3 mb-0">
						Skills
					</label>
					<p class="col-sm-9 mb-0">{{ inputs.skill }}</p>
				</div>
                <div class="form-group row align-items-center">
					<label for="inputs_score_1" class="col-sm-3 mb-0">
						Score
					</label>
					<app-input
						id="inputs_score_1"
						class="col-sm-9"
						type="number"
						v-model="inputs.score_1"
						placeholder="Score"
						:required="true"
					/>
				</div>
                <!-- <div class="form-group row align-items-center">
					<label for="inputs_score_2" class="col-sm-3 mb-0">
						普
					</label>
					<app-input
						id="inputs_score_2"
						class="col-sm-9"
						type="number"
						v-model="inputs.score_2"
						placeholder="普"
						:required="true"
					/>
				</div> -->
                <!-- <div class="form-group row align-items-center">
					<label for="inputs_score_3" class="col-sm-3 mb-0">
						差
					</label>
					<app-input
						id="inputs_score_3"
						class="col-sm-9"
						type="number"
						v-model="inputs.score_3"
						placeholder="差"
						:required="true"
					/>
				</div> -->
                <!-- <div class="form-group row align-items-center">
					<label for="inputs_score_4" class="col-sm-3 mb-0">
						无
					</label>
					<app-input
						id="inputs_score_4"
						class="col-sm-9"
						type="number"
						v-model="inputs.score_4"
						placeholder="无"
						:required="true"
					/>
				</div> -->
                <!-- <div class="form-group row align-items-center">
					<label for="inputs_score_5" class="col-sm-3 mb-0">
						未
					</label>
					<app-input
						id="inputs_score_5"
						class="col-sm-9"
						type="number"
						v-model="inputs.score_5"
						placeholder="未"
						:required="true"
					/>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { ClassTrialSkillsFormMixin } from "./ClassTrialSkillsFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ClassTrialSkillsTableForm",
	mixins: [ClassTrialSkillsFormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.inputs.score_1 = parseInt(this.inputs.score_1)
			if (this.inputs.score_1 > 5 || this.inputs.score_1 < 0) {
				this.$toastr.e("Score must be between 0 and 5");
				return;
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
